<template>
  <div>
    <v-toolbar flat color="white" class="elevation-2" >
      <v-toolbar-items class="hidden-sm-and-down pt-4">
        <span v-for="(item, index) in datatable.header.options" :key="index">
          <span v-if="item.hidden == ''">
            <v-btn v-if="item.action" small :color="item.color" dark class='mr-1' @click="action(item)" >
                {{ item.title }}
                <v-icon right dark v-if="item.icon">{{ item.icon }}</v-icon>
            </v-btn>
            <v-menu v-else offset-y>
                <template v-slot:activator="{ attrs, on }">
                    <v-btn color="teal darken-1" class="white--text" v-bind="attrs" v-on="on" small>
                        {{item.title}} <v-icon right dark>{{item.icon}}</v-icon>
                    </v-btn>
                </template>
                <v-list dense>
                    <v-list-item v-for="(option, index) in item.options" :key="index" @click="action(option)" link dense>
                        <v-list-item-icon>
                          <v-icon>{{option.icon}}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-subtitle>{{ option.title }}</v-list-item-subtitle>
                    </v-list-item>
                </v-list>
            </v-menu>
          </span>
        </span>
      </v-toolbar-items>
      <span class="hidden-md-and-up">
        <v-menu>
            <template v-slot:activator="{ attrs, on }">
              <v-app-bar-nav-icon v-bind="attrs" v-on="on" small></v-app-bar-nav-icon>
            </template>
            <v-list dense>
              <span v-for="(item, index) in datatable.header.options" :key="index">
                <span v-if="item.hidden == ''">
                  <v-list-item v-if="item.action" @click="action(item)" link dense>
                      <v-list-item-icon>
                        <v-icon>{{item.icon}}</v-icon>
                      </v-list-item-icon>
                      <v-list-item-subtitle>{{ item.title }}</v-list-item-subtitle>
                  </v-list-item>
                  <v-list-group v-else :value="true" no-action sub-group>
                    <template v-slot:activator>
                      <v-list-item-content>
                        <v-list-item-title>{{item.title}} <v-icon right dark>{{item.icon}}</v-icon></v-list-item-title>
                      </v-list-item-content>
                    </template>
                    <v-list-item v-for="(option, index) in item.options" :key="index" @click="action(option)" link dense>
                        <v-list-item-icon>
                          <v-icon>{{option.icon}}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-subtitle>{{ option.title }}</v-list-item-subtitle>
                    </v-list-item>
                  </v-list-group>
                </span>
              </span>
            </v-list>
        </v-menu>
      </span>

      <v-spacer></v-spacer>

      <DatePickerOnlyYear v-if="datatable.header.select_year" class="inputSearch" :itemAction="DatePickerYearField" :on-success="actionFieldData"/>
      <v-divider vertical inset class="mx-3 black-text" />
      <v-text-field v-model="buscar" label="Buscar" class="inputSearch"  @keyup="searchData" @click:clear="clearDataSerarch()" clearable outlined dense>
          <!-- @keyup="searchData" -->
          <!-- @click:clear="clearDataSerarch()" -->
      </v-text-field>
      <v-btn v-if="datatable.header.filter" @click="items({ action: 'filterData' })"
        color="blue-grey darken-1" class="ml-3 white--text" >
        <v-icon dark>mdi-filter</v-icon>
      </v-btn>
    </v-toolbar>

    <v-data-table
        v-model="datatable.modelMain"
        :item-key="datatable.itemKey"
        :show-select="datatable.showSelect"
        :single-select="datatable.singleSelect"
        :headers="datatable.header.titles"
        :items="datatable.body.data"
        :options.sync="pagination"
        :update:pagination="pagination"
        :server-items-length="datatable.body.totalData"
        :hide-default-footer="!datatable.footer.paging"
        :footer-props="footer"
        :loading="datatable.header.loading"
        loading-text="Cargando por favor espere"
        class="elevation-1"
        dense>
        <template #no-data>
          <v-alert :value="true" color="info" class="ma-1" border="left" type="info" icon="warning" dense>
            Lo siento, no hay registros para mostrar :(
          </v-alert>
        </template>
        <template #footer.page-text="props">
          {{props.pageStart}} - {{props.pageStop}} de {{props.itemsLength}}
        </template>

        <template #item.Status="{ item }">
          <v-chip v-if="item.last_movement"
            class="font-weight-bold text-uppercase" :color="item.last_movement.estatus.color" outlined label small>
            {{ item.last_movement.estatus.estatus }}
          </v-chip>
        </template>
        <template #item.Activo="{ item }">
          <v-chip class="ma-1" :color="(item.activo == 'si')? 'success':'error'" outlined label small>
            <span class="font-weight-bold text-uppercase">{{ item.activo }}</span>
          </v-chip>
        </template>

        <template v-slot:item.ObjetDateDinamic="{item, header}">
          {{ ObjectDateFormat({item: item, ItemColum: header.showItemColum}) }}
        </template>
        <template v-slot:item.DinamicObjectData="{ item, header }">
          {{ ShowDataObject(item, header) }}
        </template>

        <template #item.Actions="{ item }">
          <span>
            <v-menu offset-y>
              <template #activator="{ attrs, on }">
                <v-btn
                  color="teal darken-1"
                  class="white--text ma-1"
                  v-bind="attrs"
                  small
                  v-on="on">
                  <v-icon>mdi-cog</v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <!-- Acciones procesos -->
                <v-list-item-group>
                  <span v-if="item.last_movement && item.last_movement.actions.length > 0">
                    <v-list-item
                      v-for="(action, index) in item.last_movement.actions"
                      :key="index"
                      link
                      @click="items({action:action.accion, item:item, body:action})"
                    >
                      <v-list-item-icon>
                        <v-icon :color="action.status_finish.color">mdi-decagram</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>{{ action.status_finish.nombre }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </span>
                </v-list-item-group>

                <!-- Divisor -->
                <v-list-item dense>
                  <v-divider />
                  <v-subheader class="black--text font-weight-bold text-center">Generales</v-subheader>
                  <v-divider />
                </v-list-item>

                <!-- Acciones Locales -->
                <v-list-item-group>
                  <span
                    v-for="(event, index) in datatable.body.actions"
                    :key="index"
                  >
                    <v-list-item
                      v-if="event.hidden == ''"
                      link
                      @click="items({action:event.action, item:item, body:action})"
                    >
                      <v-list-item-icon>
                        <v-icon :color="event.color">{{ event.icon }}</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title> {{ event.title }} </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </span>
                </v-list-item-group>
              </v-list>
            </v-menu>
          </span>
        </template>
        <template #item.ActionsGral="{ item }">
          <span>
            <v-menu offset-y>
              <template #activator="{ attrs, on }">
                <v-btn
                  color="teal darken-1"
                  class="white--text ma-1"
                  v-bind="attrs"
                  small
                  v-on="on">
                  <v-icon>mdi-cog</v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <!-- Acciones Locales -->
                <v-list-item-group>
                  <span v-for="(event, index) in datatable.body.actions" :key="index">
                    <v-list-item v-if="event.hidden == ''" link @click="items({action:event.action, item:item, body:action})">
                      <v-list-item-icon>
                        <v-icon :color="event.color">{{ event.icon }}</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-bold black--text subtitle-2"> {{ event.title }} </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </span>
                </v-list-item-group>
              </v-list>
            </v-menu>
          </span>
        </template>

        <template #item.Created="{ item }">
          {{ convertDate(item.created_at) }}
        </template>
        <template #item.Updated="{ item }">
          {{ convertDate(item.updated_at) }}
        </template>
    </v-data-table>
  </div>
</template>

<script>
import { NumberUtils } from '@/mixins/NumberMixin'
import { DatesUtils } from '@/mixins/datesUtilsMixin'
import { Validate } from '@/mixins/validateFormMixin'
import DatePickerOnlyYear from '@/components/fields/DatePickerOnlyYear'
export default {
  name: 'TableMain',
  mixins: [Validate, DatesUtils, NumberUtils],
  props: ['datatable', 'onSuccess', 'itemsAction', 'onPagination', 'onSearch'],
  data: () => ({
    expand: false,
    buscar: '',
    countbuscar: 0,
    footer: {
      showFirstLastPage: true,
      'items-per-page-text': 'Registros por página'
    },
    pagination: {},
    timeout: null,
    excluir: ['Shift', 'Control', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'],
    DatePickerYearField: { field: 'textDatePicker', name: 'Año', nameid: 'year', cantidad: 15, default: true, cols: 4 }
  }),
  components: {
    DatePickerOnlyYear
  },
  methods: {
    action (item) {
      if (item.pagination) {
        item.pagination = this.pagination
      }
      this.onSuccess(item)
    },
    items (item) {
      this.itemsAction(item)
    },
    actionFieldData (obj) {
      this.items({ action: 'SelectYear', item: { [obj.id]: obj.data }, body: null })
    },

    convertDate (date) {
      const dateString = new Date(date).toISOString().substr(0, 10)
      const timeString = new Date(date).toLocaleTimeString()

      return `${dateString} ${timeString}`
    },
    searchData (val) {
      const exist = this.excluir.find(key => key === val.key)
      if (exist) return
      clearTimeout(this.timeout)
      var self = this
      this.timeout = setTimeout(function () {
        clearTimeout(self.timeout)
        if (self.buscar === '') {
          self.countbuscar = 0
          self.pagination.search = ''
          self.onPagination(self.pagination)
        } else {
          if (self.countbuscar !== self.buscar.length) {
            self.countbuscar = self.buscar.length
            self.pagination.page = 1
          }
          self.pagination.search = self.buscar
          self.onSearch(self.pagination)
        }
      }, 300)
    },
    clearDataSerarch () {
      this.countbuscar = 0
      this.pagination.search = ''
      this.onPagination(this.pagination)
    },
    ObjectDateFormat ({ item, ItemColum }) {
      const objetsName = ItemColum.split('.')
      let lastobjet = item
      let exist = true
      objetsName.map(obj => {
        if (lastobjet[obj]) {
          lastobjet = lastobjet[obj]
        } else {
          exist = false
        }
      })
      if (exist) {
        return this.formatoFechaAbreviacion(lastobjet)
      }
      return ''
    },
    ShowDataObject (item, header) {
      const arbol = header.fieldMain.split('.')
      // console.log(item)
      let data = null
      arbol.map(i => {
        if (data) data = data[i]
        else data = item[i]
      })
      if (header.type === 'number' || header.type === 'textcenter') {
        if (!data) return 0
      } else if (header.type === 'importe') {
        if (!data) return 0
        return `$${this.intlRound(data)}`
      } else if (header.type === 'json') {
        return JSON.stringify(data)
      }
      return data
    }
  },
  watch: {
    pagination (val) {
      if (this.buscar) {
        if (this.countbuscar !== this.buscar.length) this.pagination.page = 1
        this.onSearch({
          itemsPerPage: val.itemsPerPage,
          page: (this.countbuscar !== this.buscar.length) ? 1 : val.page,
          search: this.buscar,
          sortDesc: this.pagination.sortDesc,
          sortBy: this.pagination.sortBy
        })
      } else {
        this.onPagination(val)
      }
    },
    buscar1 (val) {
      // console.log(this.pagination)
      if (val === null || val === '') {
        this.onPagination(val)
        return
      }
      this.onSearch({
        itemsPerPage: this.pagination.itemsPerPage,
        page: this.pagination.page,
        search: val,
        sortDesc: this.pagination.sortDesc,
        sortBy: this.pagination.sortBy
      }) // .replace(' ', '_')
    }
  }
}
</script>

<style>
.inputSearch{
  padding-top: 25px !important;
}
</style>
